import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HISTORY_API_BASE_URL } from '../../api-base-url.token';
import {
    TradingProcedureOrganizationStatisticResponseDto
} from '../../schemas/organization-responses/trading-procedure-organization-statistic-response.dto';

@Injectable({ providedIn: 'root' })
export class TradingProcedureStatisticAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(HISTORY_API_BASE_URL)}/tradingProcedureStatisticAdmin`;

    getOrganizationStatistics(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getOrganizationStatistics`)
            .get()
            .json<TradingProcedureOrganizationStatisticResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }
}
